import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { WhitelabelId } from '@whitelabel/WhitelabelId';

export const useIsJTB = () => {
    const { whitelabelId } = useAppContext();
    return whitelabelId === WhitelabelId.JTB || whitelabelId === WhitelabelId.JTBUAT;
};
